const prefix = 'spk-hub-swr-'
const cache = {
  prefix,
  map: new Map(),
  get(key: string) {
    return cache.map.get(key)
  },
  set(key: string, value: any) {
    cache.map.set(key, value)
    if (!key.startsWith('$swr$')) {
      if (value === undefined) {
        sessionStorage.removeItem(`${prefix}${key}`)
      }
      else {
        sessionStorage.setItem(`${prefix}${key}`, JSON.stringify({ value, cached: Date.now() }))
      }
    }
  },
  delete(key: string) {
    cache.map.delete(key)
    sessionStorage.removeItem(`${prefix}${key}`)
  },
  init() {
    for (const key of Object.keys(sessionStorage)) {
      const json = key.startsWith(prefix) && sessionStorage.getItem(key)
      if (json) {
        try {
          const value = JSON.parse(json)?.value
          if (value !== undefined) {
            cache.set(
              key.slice(prefix.length),
              value,
            )
          }
        }
        catch (e) {
          // eslint-disable-next-line no-console
          console.error('failed to parse cached value', key, json, e)
        }
      }
    }
  }
}
export default cache
